var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.523,
    height: 18.482,
    viewBox: "0 0 23.523 18.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2428",
    "data-name": "Caminho 2428",
    d: "M11.791,22.456a5.041,5.041,0,1,1,5.041-5.041A5.041,5.041,0,0,1,11.791,22.456Zm0-8.4a3.36,3.36,0,1,0,3.36,3.36A3.36,3.36,0,0,0,11.791,14.055Z",
    transform: "translate(-3.39 -7.334)",
    fill: "#7e84a3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2429",
    "data-name": "Caminho 2429",
    d: "M24.933,24.107H3.09a.84.84,0,0,1-.84-.84V6.465a.84.84,0,0,1,.84-.84H24.933a.84.84,0,0,1,.84.84v16.8A.84.84,0,0,1,24.933,24.107Zm-21-1.68H24.093V7.305H3.93Z",
    transform: "translate(-2.25 -5.625)",
    fill: "#7e84a3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2430",
    "data-name": "Caminho 2430",
    d: "M21.375,10.125h5.881v1.68H21.375Z",
    transform: "translate(-7.093 -6.765)",
    fill: "#7e84a3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2431",
    "data-name": "Caminho 2431",
    d: "M14.055,18.84a.84.84,0,1,1-.84-.84A.84.84,0,0,1,14.055,18.84Z",
    transform: "translate(-4.814 -8.759)",
    fill: "#7e84a3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.f5b1e7023e07d5be53c12cad5f0cc2ae.svg";
export { ForwardRef as ReactComponent };